import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { settleLanguage } from "./i18n";
import { settleTheme } from "./lib/theme";
import { isPublicRoute } from "./publicRoutes";
import "./styles.css";
import "./scents.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

// Before the first paint, not after: a theme applied once React has rendered is
// a white flash on a dark phone, which is the thing the dark theme is for.
settleTheme(window.location.pathname);
// The same moment for the language: every `t()` reads it as the screen is
// built, and a customer's page is pinned to English here (ADR 0325). The
// pages pinned are the ones App answers as public, from the same list.
settleLanguage(
  window.location.pathname,
  isPublicRoute(window.location.pathname),
);

// Changing the language redraws the screens, keyed in App below its own
// startup work; see the comment on `lang` there.
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
